export class NationalOrganizationReport {
    campaignId:Number;
    campaignTitle:string
    dateFrom:string
    dateTo:string
    
}
